import { render, staticRenderFns } from "./PatientManagement.vue?vue&type=template&id=336446a2&scoped=true&"
import script from "./PatientManagement.vue?vue&type=script&lang=js&"
export * from "./PatientManagement.vue?vue&type=script&lang=js&"
import style0 from "./PatientManagement.vue?vue&type=style&index=0&id=336446a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336446a2",
  null
  
)

export default component.exports